<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini" style="width: 100%;">
         <div class="formItemBox">
            <el-form-item label="角色名称:" prop="name">
              <el-input  placeholder="" v-model="searchFrom.name"></el-input>
            </el-form-item>
            <el-form-item label="角色类型:" type="type">
                <el-select  v-model="searchFrom.type"  placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="业务角色" value="1"></el-option>
                  <el-option label="普通角色" value="2"></el-option>
                </el-select>
            </el-form-item>
        </div>
       <div class="searchBtnBox" style="margin-top:10px;margin-bottom:10px;">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item >
            <el-button type="primary"  @click="addFn">新增</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"    @click="editFn(scope.row)">修改</el-button>
              <!-- <el-button type="text" size="mini" @click="tingqiFN(scope.row)">{{scope.row.enableFlag==1?'停用':'启用'}}</el-button> -->
              <el-button type="text" size="mini"   @click="delFn(scope.row)">删除</el-button>
            </template>
        </el-table-column>
        <el-table-column prop="name"  min-width="200" :formatter="emptyFn" label="角色名称"></el-table-column>
        <el-table-column property="type" label="角色类型" min-width="100">
          <template scope="scope">
            <div>
           {{[ "业务角色", "普通角色"][scope.row.type-1]}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="isCarHold" label="用户" min-width="100">
          <template scope="scope">
             <el-button type="text" size="mini" btnCode="00KP002B003"   @click="yonghuFn(scope.row)">{{scope.row.number}}</el-button>
          </template>
        </el-table-column>
       <el-table-column prop="createUserName" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" min-width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-drawer :title="title" @close="closeDialog"  direction="ltr" size="50%"  :visible.sync="dialogVisible">
      <div>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
          <div class="inpBox" style="padding-top:20px">
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
            <el-form-item label="角色名称" prop="name">
              <el-input   maxlength="50"  :validate-event="false"  placeholder  v-model.trim="addFrom.name"  ></el-input>
            </el-form-item>
            <el-form-item label="角色类型:" prop="type">
                <el-select  v-model="addFrom.type"  placeholder="请选择"  :disabled="!isAdd">
                  <el-option label="业务角色" :value=1></el-option>
                  <el-option label="普通角色" :value=2></el-option>
                </el-select>
            </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>系统模块</span>
              </h4>
            </div>
            <div>
              <div style="padding:20px">
                 <h6>已选中的模块:</h6>
                 <template  v-for="(item,index) in QXList">
                     <el-tag closable :key="item.id" @close="scmkFN(index)" v-if="!item.isDel" >
                      <i class="fa fa-television" aria-hidden="true" v-if="item.clientClassify==1"></i>
                      <i class="el-icon-mobile-phone"  v-if="item.clientClassify==2"></i>
                      {{ item.moduleName }}
                    </el-tag>
                 </template>
              </div>
              <div style="padding:20px">
                 <h6>WEB端模块:</h6>
                  <el-tag v-for="item in mokuaiList"  effect="dark" :key="item.id" @click="xzmkFN(item)" >
                    {{ item.name }}
                  </el-tag>
                <h6>APP端模块:</h6>
                <el-tag v-for="item in mokuaiListAPP"  effect="dark" :key="item.id" @click="xzmkFN(item)" >
                  {{ item.name }}
                </el-tag>

              </div>
            </div>
          </div>
         </el-form>
          <div class="footerBox">
            <el-button   @click="dialogVisible=false" style="padding: 12px 40px;">取消</el-button>
            <el-button type="primary"  size="medium"  style="padding: 12px 40px;" @click="saveFn()">确定</el-button>
          </div>
      </div>
      <el-drawer title="功能权限" size="90%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible.sync="dialogVisible">
          <p v-if="QXList.length==0" style="text-align: center;">暂无数据</p>
          <ul v-else class="ul">
            <template v-for="(item,index) in QXList">
               <li  :key="item.id"  style="margin:20px" v-if="!item.isDel">
                <h5 ><i class="fa fa-bars" aria-hidden="true"></i> {{item.moduleName}}</h5>
                <div class="shuBox" >
                  <el-tree
                      :data="item.sMenuTreeList"
                      :props="defaultProps"
                      show-checkbox
                      ref="menuTree"
                      node-key="id"
                      :default-expand-all="true"
                      :expand-on-click-node="false"
                      :highlight-current="true"
                      @node-click="handleNodeClick($event,index)"
                      :render-content="renderContent"
                    >
                  </el-tree>
                </div>
              </li>
            </template>
          </ul>
      </el-drawer>
  </el-drawer>
  <!-- 用户列表 -->
  <roleUser :row-data="row" @destroy="userFlag=false" v-if="userFlag"></roleUser>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { listModule, sRoleList, sMenuTreeByModuleId, sRoleAdd, sRoleUpdate, sRoleDelete, sRoleEnableOrDisable, sMenuTreeByPlatformRoleId } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat, arrChaJi } from '@/utils/util'
import roleUser from '@/views/newCrm/components/roleUser.vue'
export default {
  components: {
    roleUser
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      arrChaJi: arrChaJi,
      mokuaiList: [],
      mokuaiListAPP: [],
      YXmokuaiList: [], // 选择得模块
      QXList: [],
      title: '添加角色',
      dialogVisible: false,
      dialogDetail: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        tenantCode: localStorage.getItem('tenantCode')
      },
      total: 0,
      loading: 'false',
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择角色类型', trigger: 'blur' }
        ]
      },
      addFrom: {
      },
      isAdd: true,
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      oldChildArr: [],
      oldAllArr: [],
      row: {},
      userFlag: false,
      btnFlg: [],
      btnIdArr: ['00KP002B001', '00KP002B002', '00KP002B003']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/basicData/shipData')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 点击字体选择取消
    handleNodeClick (data, index) {
      let checkedArr = []
      this.$refs.menuTree.forEach((item, index) => {
        checkedArr.push(...item.getCheckedNodes(false, true))
      })
      const n = checkedArr.findIndex(d => d.id === data.id)
      if (n > -1) {
        this.$refs.menuTree[index].setChecked(data, false, true)
      } else {
        this.$refs.menuTree[index].setChecked(data, true, true)
      }
    },
    // 用户
    yonghuFn (row) {
      this.row = row
      this.userFlag = true
    },
    // 选择模块
    xzmkFN (item) {
      let flag = this.QXList.some(e => e.moduleId == item.id && !e.isDel)
      if (flag) {
        this.$message({
          message: '该模块已经选择',
          type: 'warning'
        })
        return
      }
      sMenuTreeByModuleId({ moduleId: item.id, enableFlag: 1 }).then(res => {
        if (res.length > 0) {
          this.QXList.push({
            moduleName: item.name,
            moduleId: item.id,
            clientClassify: item.clientClassify,
            sMenuTreeList: res
          })
        } else {
          this.$message({
            message: '该模块下没有可选菜单',
            type: 'warning'
          })
        }
      })
    },
    // 删除模块
    scmkFN (index) {
      this.$set(this.QXList[index], 'isDel', true)// 只是让树隐藏，不删除，否则选中的值会清空
      // this.QXList.splice(index, 1)
    },
    // 添加
    addFn () {
      this.title = '添加角色'
      listModule().then(res => {
        this.mokuaiList = res.WEB
        this.mokuaiListAPP = res.APP
      })
      this.addFrom = {

      }
      this.dialogVisible = true
      this.isAdd = true
    },

    // 修改
    editFn (row) {
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
      this.addFrom = {
        name: row.name,
        id: row.id,
        type: row.type
      }
      listModule().then(res => {
        this.mokuaiList = res.WEB
        this.mokuaiListAPP = res.APP
      })
      sMenuTreeByPlatformRoleId({ roleId: row.id }).then(res => {
        this.QXList = res.list
        this.oldChildArr = res.menuChildAllList
        this.oldAllArr = res.menuAllList
        this.$nextTick(function () {
          this.$refs.menuTree.forEach((item, index) => {
            item.setCheckedKeys(res.list[index].menuChildList)
          })
        })
      })
    },
    saveFn () {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          if (!this.$refs.menuTree) {
            this.$alert('请选择模块', '系统提示')
            return
          }
          let checkedArr = []
          let checkedChIds = []
          this.$refs.menuTree.forEach((item, index) => {
            checkedArr.push(...item.getCheckedNodes(false, true))
            checkedChIds.push(...item.getCheckedKeys(true))
          })
          if (checkedArr.length == 0) {
            this.$alert('请选择菜单', '系统提示')
            return
          }
          let menuIds = []

          checkedArr.forEach(item => {
            menuIds.push(item.id)
          })
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.addFrom.parentMenuIds = this.arrChaJi(menuIds, checkedChIds, 1)// 取两个数组得差集
            this.addFrom.childMenuIds = checkedChIds
            this.addFrom.tenantCode = localStorage.getItem('tenantCode')
            this.addFrom.tenantName = localStorage.getItem('tenantName')
            this.addFrom.usetenantName = localStorage.getItem('tenantName')
            this.addFrom.useTenantCode = localStorage.getItem('tenantCode')
            sRoleAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            this.addFrom.childMenuIds = this.arrChaJi(this.oldChildArr, checkedChIds, 2)// 新增得子
            let addAllArr = this.arrChaJi(this.oldAllArr, menuIds, 2)// 新增得全部
            this.addFrom.parentMenuIds = this.arrChaJi(this.addFrom.childMenuIds, addAllArr, 2)// 新增得父
            this.addFrom.delMenuIds = this.arrChaJi(this.oldAllArr, menuIds, 1)// 删除得全部
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sRoleUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 树得格式化
    renderContent (h, { node, data, store }) {
      if (data.aliasName) {
        return (
          <span class="custom-tree-node">
            <span style="font-size:16px">{data.name + '（' + data.aliasName + '）'}</span>
          </span>)
      } else {
        return (
          <span class="custom-tree-node">
            <span style="font-size:16px">{data.name }</span>
          </span>)
      }
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      sRoleList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 停用启用
    tingqiFN (row) {
      let str = ''
      if (row.enableFlag == 1) { // 启用状态
        str = '停用'
      } else {
        str = '启用'
      }
      this.$confirm('是否执行' + str + '操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sRoleEnableOrDisable({ id: row.id, enableFlag: row.enableFlag == 1 ? 0 : 1, parentId: this.currentData.parentId }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 删除
    delFn  (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sRoleDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        tenantCode: localStorage.getItem('tenantCode'),
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = {

      }
      this.QXList = []
    }
  }
}
</script>

<style scoped lang='less'>
.ul{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  li{
    width: 45%;
  }
  h5{
    margin: 0;
    margin-bottom: 20px;
  }
  .fa{
    color:#0c46a2;
  }
}
/deep/.el-tag{
  margin-right:15px;
  margin-bottom: 15px;
  display: inline-block;
  width: 22%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
 .el-tag__close{
    position: absolute;
    right: 2px;
    top: 8px;
  }
}
/deep/.el-tag:hover{
    background-color: #056fdd;
    color: #fff;
}
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/.inpBox .el-input__inner{
  width:180px;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.el-checkbox__inner{
      width: 18px;
    height: 18px;
    margin-right: 10px;
}
/deep/.el-checkbox__inner::after{
    height: 9px;
    left: 6px;
    top: 1px;
}
</style>
